import { useSelector } from 'react-redux';
import Workspace from 'src/entities/workspace';
import { getWorkspace } from 'src/selectors/workspaces';
import ScimProvisioningCard from './ScimProvisioningCard';
import ScimEnterprisePaywall from './ScimEnterprisePaywall';

import './WorkspaceProvisioningTab.scss';

const WorkspaceProvisioningTab = ( { workspaceID }: { workspaceID: number } ) => {
	// @ts-expect-error - TODO: fix this
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const workspace: Workspace = useSelector( ( state: any ) => getWorkspace( state, { workspaceID } ) );

	return (
		<div className="WorkspaceProvisioningTab">
			{workspace.scimEnabled && workspace.scimManageableByCurrentUser
				? <ScimProvisioningCard workspaceID={workspaceID} />
				: <ScimEnterprisePaywall />}
		</div>
	);
};

export default WorkspaceProvisioningTab;
